import { render, staticRenderFns } from "./MyPets.vue?vue&type=template&id=19ea435e&"
import script from "./MyPets.vue?vue&type=script&lang=js&"
export * from "./MyPets.vue?vue&type=script&lang=js&"
import style0 from "./MyPets.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports